import { render, staticRenderFns } from "./EditedDoctor.vue?vue&type=template&id=518190fd&"
import script from "./EditedDoctor.vue?vue&type=script&lang=js&"
export * from "./EditedDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports